module.exports = __webpack_public_path__ + "static/media/video-screenhost.0b75ffca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/video-screenhost.jpg
// module id = 99
// module chunks = 0